var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "login", attrs: { id: "page" } },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c("b-col", { attrs: { md: "6", "offset-md": "3" } }, [
                _c(
                  "div",
                  { staticClass: "login-panel" },
                  [
                    _c(
                      "div",
                      { staticClass: "login-logo" },
                      [
                        _c(
                          "b-link",
                          { attrs: { to: { name: "home" } } },
                          [_c("logo", { attrs: { size: "sm" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", { staticClass: "text-center" }, [
                      _c("strong", [
                        _vm._v("Please enter your new password here"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("auth-reset-password-form"),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "login-footer-actions" },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { attrs: { sm: "6" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant: "outline-primary",
                                      block: "",
                                      size: "sm",
                                      to: { name: "login" },
                                    },
                                  },
                                  [_vm._v("Login")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { attrs: { sm: "6" } },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant: "outline-primary",
                                      block: "",
                                      size: "sm",
                                      href: _vm.applyUrl,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Apply for Membership\n                "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }